// TODO: This should be split into multiple, smaller components
import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import {
  restorePage,
  setHomePage,
} from 'src/common/components/emerald-home-page/emerald-home-page';
import { TenderType } from 'src/common/enumerations/tender-type';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { ITenderGroup } from 'src/common/interfaces/dtos/ITenderGroup';
import { AppState, store } from 'src/common/redux/configure-store';
import { TenderingActions } from 'src/common/redux/reducers/tendering-reducer';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { getCardData } from 'src/devices/payment/get-card-details';
import { findMatchingTenderInStore } from 'src/tendering/business-logic/handle-tender-payment';
import TenderAmountDue from '../tender-amount-due';
import TenderProcessingTitle from './tender-processing-title';
import { styles } from './tender-processing-view-styles';

type Props = TenderProcessingViewProps & TenderingProcessPageProps;

export const showEftTenderingView = (onExit: () => void): void => {
  const defaultCardEntryPrompt = 'EFTTenderCardPrompt';
  store.dispatch(TenderingActions.setPaymentInfoText(defaultCardEntryPrompt));
  setHomePage(<TenderingProcessingView onExit={onExit} />, undefined, { isReplaceablePage: true });
};

export const shiftToTenderingView = (): void => {
  setHomePage(<TenderingProcessingView />, undefined, { isReplaceablePage: true });
};

export const closeEftTenderingView = () => restorePage();

interface TenderingProcessPageProps {
  onExit?: () => void;
}

interface TenderProcessingViewProps {
  amountDue: number;
  paymentInfo: string;
  tenderGroup?: ITenderGroup;
  hasCardData: boolean;
  isTenderExchange: boolean;
}

const mapStateToProps = (state: AppState): TenderProcessingViewProps => ({
  amountDue: state.itemList.amountDue,
  paymentInfo: state.tendering.paymentInfoText,
  tenderGroup: state.tenderMenu.selectedTenderGroup,
  hasCardData: state.pinPad.hasCardData,
  isTenderExchange: state.tenderExchange.isTenderExchange,
});

const isLeftHanded = CashierPreferencesHelper.isLeftHanded();

const TenderProcessingPage = ({
  paymentInfo,
  amountDue,
  tenderGroup,
  hasCardData,
  isTenderExchange,
  onExit,
}: Props): JSX.Element => {
  const classes = styles();
  const trainingClasses = trainingModeStyles();
  const { t } = useTranslation();
  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);
  let titleText;
  if (isTenderExchange) {
    titleText = t('CreditDebitTenderTitle');
  } else {
    if (hasCardData) {
      titleText = findMatchingTenderInStore(getCardData())?.type === TenderType.CreditDebit ? t('CreditDebitTenderTitle') : findMatchingTenderInStore(getCardData())?.type;
    } else {
      titleText = tenderGroup?.name || t('Checkout')
    }
  }

  return (
    <Grid
      item
      container
      direction='row'
      justifyContent='space-between'
      className={clsx('fullHeight', 'flexFull', classes.viewContainer, {
        [trainingClasses.trainingModeBackground]: trainingModeActive,
      })}
    >
      {trainingModeActive && (
        <TrainingModeWatermark
          supplementalStyles={trainingClasses.trainingWaterMark}
          dataTestId='action-window-training-mode-watermark'
        />
      )}

      <Grid
        item
        container
        direction='row'
        justifyContent='space-between'
        className={classes.viewHeader}
      >
        <Grid item lg={9}>
          <TenderProcessingTitle
            title={titleText || t('CreditDebitTenderTitle')}
          />
        </Grid>
        <Grid item>
          <TenderAmountDue amountDue={amountDue} align='right' />
        </Grid>
      </Grid>

      {!isLeftHanded && (
        <Grid
          item
          container
          direction='row'
          className={classes.rightHandedContent}
          style={{ alignContent: 'flex-start' }}
        >
          <CenterMessagingColumn paymentInfo={paymentInfo} />
        </Grid>
      )}

      {isLeftHanded && (
        <Grid item container direction='row' className={classes.leftHandedContent}>
          <CenterMessagingColumn paymentInfo={paymentInfo} />
        </Grid>
      )}
      <Grid item container direction='row' alignContent={'flex-end'}>
        <Grid item container direction='row' className={classes.exitButtonContainer}>
          <BaseButton
            buttonType='primary'
            className={classes.exitButton}
            disabled={hasCardData}
            onClick={() => (onExit ? onExit() : () => {})}
            data-testid='tender-processing-exit'
          >
            {t('TenderProcessingExit')}
          </BaseButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

const TenderingProcessingView = connect(mapStateToProps)(TenderProcessingPage);
export default TenderingProcessingView;

interface CenterMessagingColumnProps {
  paymentInfo: string;
}

const CenterMessagingColumn = ({ paymentInfo }: CenterMessagingColumnProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  return (
    <Grid item container md={7} direction='column' className={classes.centerMessaging}>
      <Grid
        item
        data-testid='payment-info'
        className={`${classes.paymentInfo} ${classes.textAlignCenter}`}
      >
        {t(paymentInfo)
          .split('\n')
          .map((str, i) => {
            const msgIndex = `msg${i.toString()}`;
            return <p key={msgIndex}>{t(str)}</p>;
          })}
      </Grid>
    </Grid>
  );
};
